import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, SelectGroup, SelectLabel } from '@/components/ui/select';
import { DatePicker } from '@/components/DatePicker';

const TaskFormFields = ({
  formData,
  projects,
  assignableEmployees,
  statuses,
  isFetchingRelatedData,
  handleChange,
  handleSelectChange,
  handleDateChange,
  task
}) => {
  return (
    <div className="space-y-6 py-4">
      <div>
        <Label htmlFor="name" className="text-slate-300">Task Name</Label>
        <Input id="name" name="name" value={formData.name} onChange={handleChange} required className="mt-1" />
      </div>
      <div>
        <Label htmlFor="description" className="text-slate-300">Description</Label>
        <Textarea id="description" name="description" value={formData.description} onChange={handleChange} className="mt-1" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="project_id" className="text-slate-300">Project</Label>
          <Select
            value={formData.project_id || ''}
            onValueChange={(value) => handleSelectChange('project_id', value)}
            disabled={isFetchingRelatedData}
          >
            <SelectTrigger id="project_id" className="w-full mt-1">
              <SelectValue placeholder="Select project" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Projects</SelectLabel>
                {projects.map((p) => (
                  <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="assignee_id" className="text-slate-300">Assignee</Label>
          <Select
            value={formData.assignee_id || ''}
            onValueChange={(value) => handleSelectChange('assignee_id', value)}
            disabled={isFetchingRelatedData || (!formData.project_id && !task)}
          >
            <SelectTrigger id="assignee_id" className="w-full mt-1">
              <SelectValue placeholder={formData.project_id || task?.project_id ? "Select assignee" : "Select project first"} />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Team Members</SelectLabel>
                {assignableEmployees.length > 0 ? assignableEmployees.map((e) => (
                  <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
                )) : (
                  <SelectItem value="no-assignees" disabled>
                    {formData.project_id || task?.project_id ? "No assignable members" : "Select a project"}
                  </SelectItem>
                )}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="status_id" className="text-slate-300">Status</Label>
          <Select
            value={formData.status_id || ''}
            onValueChange={(value) => handleSelectChange('status_id', value)}
            disabled={isFetchingRelatedData}
          >
            <SelectTrigger id="status_id" className="w-full mt-1">
              <SelectValue placeholder="Select status" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Statuses</SelectLabel>
                {statuses.map((s) => (
                  <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <div>
          <DatePicker
            id="due_date"
            label="Due Date"
            value={formData.due_date}
            onChange={(date) => handleDateChange('due_date', date)}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskFormFields;